<script setup lang="ts">
import type { Partner, UpdatePartnerDto } from '@/api-swagger'
import { defineProps, ref } from 'vue'
import { usePartnerStore } from '@/stores/usePartnerStore'
import Modal from '@/components/common/layout/Modal.vue'
import IconPencilSquare from '@/assets/icons/pencil-square.svg'
import { storeToRefs } from 'pinia'
import { useToast } from 'vue-toast-notification'
// import '@morpheme/quill-editor/dist/style.css'
import SaveButton from '@/components/common/buttons/SaveButton.vue'
import TextInput from '@/components/common/inputs/TextInput.vue'
import NumberInput from '@/components/common/inputs/NumberInput.vue'

const showModal = ref<boolean>(false)
const $toast = useToast()

const props = defineProps({
  partner: {
    type: Object as () => Partner,
    required: true,
  },
})

const partnerStore = usePartnerStore()
const { loading } = storeToRefs(partnerStore)

const onSubmit = async () => {
  const updatePartner: UpdatePartnerDto = {
    phone: props.partner.phone,
    mobile: props.partner.mobile,
    companyWorkforce: props.partner.companyWorkforce || 0,
    type: null,
    isCompany: true,
  }

  await partnerStore
    .updatePartner(props.partner.id, updatePartner)
    .then((res) => {
      Object.assign(props.partner, res)
      $toast.success('Client modifié avec succès.')
      closeModal()
    })
    .catch((error) => {
      $toast.error(error.message)
    })
}

function openModal() {
  showModal.value = true
}

function closeModal() {
  showModal.value = false
}
</script>

<template>
  <div class="tooltip" data-tip="Editer">
    <component :is="IconPencilSquare" @click="openModal" class="cursor-pointer" />
  </div>
  <Modal :showModal="showModal" @close="closeModal" :title="partner!.name" :loading="loading">
    <template #content>
      <form @submit.prevent="onSubmit" class="space-y-4">
        <div class="grid lg:grid-cols-2 gap-4">
          <TextInput v-model="partner!.mobile" label="Mobile" placeholder="Mobile" />
          <TextInput label="Fixe" v-model="partner!.phone" placeholder="Fixe" />
          <NumberInput
            label="Nombre d'employés"
            v-model="partner!.companyWorkforce"
            placeholder="0"
          />
        </div>
        <SaveButton :loading="loading" />
      </form>
    </template>
  </Modal>
</template>
